import { render, staticRenderFns } from "./sso-google.vue?vue&type=template&id=46007c84&"
import script from "./sso-google.ts?vue&type=script&lang=ts&"
export * from "./sso-google.ts?vue&type=script&lang=ts&"
import style0 from "./sso-google.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports